import GridLayout from 'packery';
import { each, on } from '../helpers/shortcuts';
import shared from './shared';

function initGalleries() {
  const galleries = document.querySelectorAll('.c-gallery__items');
  if (galleries.length < 1) {
    return;
  }

  const galleryContainer = document.querySelector('.pswp');

  if (galleryContainer === null) {
    return;
  }

  each(galleries, (galleryElement, galleryIndex) => {
    const links = galleryElement.querySelectorAll('[data-size]');

    if (links.length < 1) {
      return;
    }

    const data = [];
    const openGallery = index => {
      const options = {
        barsSize: { top: 30, bottom: 30 },
        captionEl: false,
        counterEl: false,
        fullscreenEl: false,
        shareEl: false,
        bgOpacity: 0.9,
        tapToClose: true,
        tapToToggleControls: false,
        showHideOpacity: true,
        showAnimationDuration: 0,
        hideAnimationDuration: 0,
        index,
        history: false,
        galleryUID: galleryIndex,
        getThumbBoundsFn: dataIndex => {
          const thumbnail = data[dataIndex].el;
          const rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + shared.scrollTop,
            w: rect.width,
          };
        },
      };
      const gallery = new window.PhotoSwipe(
        galleryContainer,
        window.PhotoSwipeUI_Default,
        data,
        options,
      );
      gallery.init();
    };

    each(links, (link, linkIndex) => {
      const size = link.getAttribute('data-size').split('x');
      const imageData = {
        src: link.href,
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10),
      };

      link.addEventListener('click', event => {
        event.preventDefault();
        openGallery(linkIndex);
      });

      data.push({
        msrc: link.firstElementChild.currentSrc,
        el: link,
        src: imageData.src,
        w: imageData.w,
        h: imageData.h,
        original: imageData,
      });
    });
  });
}

function initMasnry() {
  const galleries = document.querySelectorAll('[data-masnry]');

  if (galleries.length < 1) {
    return;
  }

  each(galleries, gallery => {
    let resizeTimeout = null;
    let updateTitles = null;

    if (gallery.classList.contains('c-gallery-index')) {
      const titles = gallery.querySelectorAll('.c-gallery-index__title');

      updateTitles = () => {
        let maxHeight = 0;
        let minHeight = -1;

        each(titles, title => {
          // eslint-disable-next-line no-param-reassign
          title.style.minHeight = 0;
        });

        each(titles, title => {
          maxHeight = Math.max(title.getBoundingClientRect().height, maxHeight);
          if (minHeight === -1) {
            minHeight = title.getBoundingClientRect().height;
          } else {
            minHeight = Math.min(
              title.getBoundingClientRect().height,
              minHeight,
            );
          }
        });

        if (maxHeight !== minHeight) {
          each(titles, title => {
            // eslint-disable-next-line no-param-reassign
            title.style.minHeight = `${maxHeight}px`;
          });
        }
      };

      updateTitles();
    }

    // eslint-disable-next-line
    const grid = new GridLayout(gallery, {
      percentPosition: true,
      columnWidth: '[data-masnry-size]',
      gutter: 0,
      itemSelector: '[data-masnry-item]',
      transitionDuration: 0,
    });

    on('resize load', window, () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (typeof updateTitles === 'function') {
          updateTitles();
        }
        grid.layout();
      }, 200);
    });
  });
}

export default () => {
  initGalleries();
  initMasnry();
};



// WEBPACK FOOTER //
// ./src/scripts/modules/gallery.js